import React, { useState } from "react";
import { Link } from "react-router-dom";
import { trackAction } from "./PageAnalytics";
import VisualLayer, { VisualBackdrop, useWideStage } from "./VisualLayer";

// A project visual: one stage of real artifacts over its backdrop. By default
// all of it is a link to the article, named after the article's own title;
// with `linked={false}` it is media only and the caption carries the action.
// With `motion`, layers that have a clip play it over their still.
// The ratio's value lets a fixed frame (the /work tiles) re-centre the
// composition it was laid out for.
export const ratioValue = (ratio) => {
  const [w, h = 1] = String(ratio).split("/").map(Number);
  return w / h;
};

function ShowcaseVisual({
  project,
  visual = project.visual,
  priority = false,
  className = "",
  linkLabel = "Read case study",
  linked = true,
  motion = false,
}) {
  const { href, title } = project;
  const [failed, setFailed] = useState(false);
  const wide = useWideStage();
  const alt = wide ? visual.alt : visual.narrowAlt || visual.alt;

  const stage = failed ? (
    <span className="pf-visual__fallback">{alt}</span>
  ) : (
    <span className="pf-visual__stage" role="img" aria-label={alt}>
      {visual.layers.map((layer, index) => (
        <VisualLayer
          key={index}
          layer={layer}
          priority={priority}
          motion={motion}
          onError={() => setFailed(true)}
        />
      ))}
    </span>
  );

  return (
    <div
      className={`pf-visual ${className}`.trim()}
      style={{
        "--pf-ratio": visual.ratio,
        "--pf-ratio-value": ratioValue(visual.ratio),
        "--pf-ratio-narrow": visual.narrowRatio,
      }}
    >
      {!failed && <VisualBackdrop backdrop={visual.backdrop} priority={priority} />}
      {linked ? (
        <Link
          to={href}
          className="pf-visual__link"
          onClick={() => trackAction("open_case_study", `${project.id}:image`)}
        >
          <span className="pf-visually-hidden">
            {linkLabel}: {title}.{" "}
          </span>
          {stage}
        </Link>
      ) : (
        stage
      )}
    </div>
  );
}

export default ShowcaseVisual;
